import React from "react";
import "./Footer.css";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer_logo">
        Ashmit Yadav
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#skill">Skill</a>
        </li>
      
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
     
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer_socials">
        <a href="https://www.facebook.com/ashmit.yadav.39" target="blank">
          <FaFacebook />
        </a>
        <a href="https://www.instagram.com/iamashmit18/" target="blank">
          <FaInstagram />
        </a>
        <a href="https://twitter.com/AshmitYadav11" target="blank">
          <FaTwitter />
        </a>
      </div>
      <div className="footer_copyright">
        <small>&copy; Ashmit Yadav. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;